import { MouseEvent, useState } from "react";

export interface AnchorElHook {
  anchorEl: null | HTMLElement;
  open: boolean;
  handleAnchorOpen: (event: MouseEvent<HTMLElement>) => void;
  handleAnchorClose: () => void;
}

export const useAnchorEl = (): AnchorElHook => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleAnchorOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAnchorClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    open,
    handleAnchorOpen,
    handleAnchorClose,
  };
};
